export default [
  {
    path: 'attendance/rules/setting',
    component: () => import('@/views/attendance/rules/rulesSetting'),
    name: 'AttendanceRulesSetting',
    meta: { title: '考勤规则', icon: 'a-up', noCache: true },
    hidden: true
  },
  {
    path: 'attendance/deduct/setting',
    component: () => import('@/views/attendance/deduct/deductSetting'),
    name: 'DeductRulesSetting',
    meta: { title: '奖惩方案', icon: 'a-up', noCache: true },
    hidden: true
  },
  {
    path: 'laborOutsourcing/attendance/scheduling/settings/:id',
    component: () => import('@/views/laborOutsourcing/attendance/scheduling/scheduleSettings/index.vue'),
    name: 'schedulingSettings',
    meta: { title: '排班设置', icon: 'a-up', noCache: true },
    hidden: true
  },
]
